import { Network } from '@capacitor/network'
import { Signal } from '@preact/signals-react'
import i18n from '../../i18n/i18next'
import { defaultAddSnack } from '../../state/overlayState/overlayContext'

export const isConnectivityAvailable = new Signal<boolean>(true)
export const isNoConnectionOpen = new Signal<boolean>(false)

Network.addListener('networkStatusChange', (status) => {
    console.log('Network status changed', status)
    if (status.connected && !isConnectivityAvailable.value) {
        isNoConnectionOpen.value = false
        defaultAddSnack(i18n.t('snack.online'), 'success', false)
    }
    if (!status.connected && isConnectivityAvailable.value) {
        isNoConnectionOpen.value = true
        defaultAddSnack(i18n.t('snack.offline'), 'error', false)
    }
    isConnectivityAvailable.value = status.connected
})
